import { useEffect, useState } from "react";
import api from "../lib/api";
import { Card, ErrorBox, Loading, PageTitle, Stat } from "./ui";
import { inr, win } from "../lib/format";

export default function Token() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([api.get("/credits/price"), api.get("/wallet/")])
      .then(([price, wallet]) => setData({ price: price.data, wallet: wallet.data }))
      .catch(() => setError("Could not load WIN Token data. Please refresh."));
  }, []);

  if (error) return <ErrorBox message={error} />;
  if (!data) return <Loading label="Loading WIN Token" />;

  const { price, wallet } = data;

  return (
    <div data-testid="token-page">
      <PageTitle title="WIN Token" sub="Limited Supply. Built for a Growing Ecosystem." />

      <div className="mt-8 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <Stat gold testId="token-supply" label="Limited Total Supply" value={`${Number(price.total_supply).toLocaleString("en-US")} WIN`} />
        <Stat testId="token-current-price" label="Current WIN Token Price" value={inr(price.price)} sub="per WIN Token" />
        <Stat testId="token-launch-price" label="Estimated Launch Price" value="$10" sub="≈ ₹1,000 · estimate only, not a guaranteed future market price" />
      </div>

      <Card className="mt-6" data-testid="token-holdings-card">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-mono text-[10px] tracking-[0.25em] text-[#636B78] uppercase">Your WIN Token Holdings</p>
            <p className="mt-3 font-display text-4xl font-extrabold tracking-tight text-gold-gradient" data-testid="token-user-balance">
              {win(wallet.total_win_credits)}
            </p>
            <p className="mt-2 text-sm text-[#99A1AF]">
              Estimated value ≈ {inr((wallet.total_win_credits || 0) * (price.price || 0))} at the current price
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6 text-sm">
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-[#636B78] uppercase">Purchased</p>
              <p className="mt-1 font-mono text-white">{win(wallet.win_credits_purchased)}</p>
            </div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-[#636B78] uppercase">Earned</p>
              <p className="mt-1 font-mono text-white">{win(wallet.win_credits_earned)}</p>
            </div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-[#636B78] uppercase">Sold Supply</p>
              <p className="mt-1 font-mono text-white">{Number(price.sold_supply || 0).toLocaleString("en-US")} WIN</p>
            </div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.2em] text-[#636B78] uppercase">Available Supply</p>
              <p className="mt-1 font-mono text-white">{Number(price.available_supply || 0).toLocaleString("en-US")} WIN</p>
            </div>
          </div>
        </div>
      </Card>

      <p className="mt-6 text-[11px] leading-relaxed text-[#636B78]">
        WIN Token balances shown here are recorded in your Winter Protocol account within the ecosystem.
        The estimated launch price is an estimate only and not a promise of future value. Digital asset
        prices can move in either direction.
      </p>
    </div>
  );
}
